import {
  RiAccountCircleFill,
  RiContactsBook2Line,
  RiHandCoinLine,
  RiKey2Line,
  RiMoneyDollarBoxLine,
  RiMoneyDollarCircleLine,
  RiShoppingBagLine,
  RiStore2Line,
} from "react-icons/ri";

const EntityIcons = {
  company: RiStore2Line,
  investor: RiMoneyDollarCircleLine,
  funding: RiHandCoinLine,
  deal: RiShoppingBagLine,
  wealth: RiMoneyDollarBoxLine,
  keyword: RiKey2Line,
  contact: RiContactsBook2Line,
  investorContact: RiContactsBook2Line,
  people: RiAccountCircleFill,
} as const;

export default EntityIcons;
